import { AuthenticatedTemplate } from '@azure/msal-react';
import { Link } from 'react-router-dom';
import { Login } from '../../../Login';
import Hero from '../../common/layout/Hero';
import HeroBody from '../../common/layout/HeroBody';
import Container from '../../common/layout/Container';
import { ThorProvider } from '../context/ThorContext';
import ExclusionGroupsManager from '../components/ExclusionGroupsManager';
import ThorToast from '../components/ThorToast';
import '../css/thor.css';

const ThorExclusionGroupsContent = () => (
    <>
        <Container>
            <Hero>
                <HeroBody>
                    <p className="title is-1">Thor</p>
                    <p className="subtitle is-5 has-text-grey">Experiment management — design, review, run, and analyze A/B tests.</p>
                </HeroBody>
            </Hero>

            <div className="tabs mb-4">
                <ul>
                    <li><Link to="/thor/experiments">Experiments</Link></li>
                    <li><Link to="/thor/audiences">Audience Library</Link></li>
                    <li className="is-active"><Link to="/thor/exclusion-groups">Exclusion Groups</Link></li>
                    <li><Link to="/thor/resurrector">Resurrector</Link></li>
                </ul>
            </div>

            <div className="box">
                <p className="subtitle is-5 mb-1">Exclusion Groups</p>
                <p className="has-text-grey is-size-7 mb-4">
                    Exclusion groups prevent two experiments from bucketing the same user into overlapping traffic slices.
                    Select a group to see and manage its experiments.
                </p>
                <ExclusionGroupsManager />
            </div>
        </Container>
        <ThorToast />
    </>
);

export const ThorExclusionGroupsPage = () => (
    <>
        <Login />
        <AuthenticatedTemplate>
            <ThorProvider>
                <ThorExclusionGroupsContent />
            </ThorProvider>
        </AuthenticatedTemplate>
    </>
);

export default ThorExclusionGroupsPage;
